module.exports = __webpack_public_path__ + "svg/new-mastercard-small.c65dc186e31405b78647b3f5c5ce91a7.svg";